export const QA_NAME_WIDGET_HEADER_EDIT_BTN = 'widgetHeaderEdit'
